var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.838,
    height: 15.838,
    viewBox: "0 0 15.838 15.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M11.294,3.375a7.919,7.919,0,1,0,7.919,7.919A7.892,7.892,0,0,0,11.294,3.375Zm3.96,10.77-1.109,1.109L11.294,12.4,8.443,15.253,7.334,14.145l2.851-2.851L7.334,8.443,8.443,7.335l2.851,2.851,2.851-2.851,1.109,1.108L12.4,11.294Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#dedede"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.62dc29f7606f775eb4b4373cc05c7e46.svg";
export { ForwardRef as ReactComponent };